import { render, staticRenderFns } from "./UserReportCard.vue?vue&type=template&id=5e99cdde&scoped=true&"
import script from "./UserReportCard.vue?vue&type=script&lang=js&"
export * from "./UserReportCard.vue?vue&type=script&lang=js&"
import style0 from "./UserReportCard.vue?vue&type=style&index=0&id=5e99cdde&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5e99cdde",
  null
  
)

export default component.exports